module.exports = __webpack_public_path__ + "kudos_52.svg?c5140646e1175248e619fc8307d0f9aa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_52.svg
// module id = 153
// module chunks = 0